import React, { /*useContext,.*/ useState } from "react";
//import { useSelector } from "react-redux";
//import { AppContext } from "../../contexts/AppContext";
import { DataSets } from "./DataSets";
import { DataItems } from "./DataItems";
import { DataSidebar } from "./data/DataSidebar";



export const Data = () => {
  const [selectedTab, setSelectedTab] = useState(window.location.hash ? window.location.hash.substr(1) : "data-items");
  const [showSidebar, setShowSidebar] = useState(true);

  return (
    <div style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--main-bg)" }}>
      <DataSidebar
        show={showSidebar}
        defaultSelectedTab={selectedTab}
        onNavItemClicked={(navItem) => {
          console.log("!!! NAV ITEM CLICKED: ", navItem);

          setSelectedTab(navItem);
        }}
        onClosed={(closed) => {
          console.log("!!! CLOSED", closed);
        }}
        onToggle={() => {
          setShowSidebar(!showSidebar);
        }}
      />

      <div
        style={{
          marginLeft: "20px",
          marginRight: "20px",
          width: `calc(100% - ${showSidebar ? "250px" : "0px"})`,
          minHeight: "calc(100vh - 40px)",
          position: "relative",
          padding: "20px",
          borderRadius: "8px",
          color: "var(--main-font-color)",
          zIndex: 1,
          /*height: "2000px",*/
        }}
      >
        <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "20px" }}>
          <DataItems
            show={selectedTab === "data-items"}
            onSelectTab={(tab) => {
              window.history.replaceState(null, null, `#${tab}`);
              setSelectedTab(tab);
            }} />
          <DataSets
            show={selectedTab === "data-sets"}
            onSelectTab={(tab) => {
              window.history.replaceState(null, null, `#${tab}`);
              setSelectedTab(tab);
            }} />
        </div>
      </div>
    </div>
  )

};

export default Data;
